import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类浏览', path: '/category/all' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-play-circle-fill text-background-50 text-xl"></i>
          </div>
          <span className={`font-heading font-bold text-lg whitespace-nowrap transition-colors ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
            麻豆cm传媒
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path))
                  ? 'text-primary-500'
                  : scrolled ? 'text-foreground-700' : 'text-background-50/90'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/category/all"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2 rounded-full whitespace-nowrap transition-all cursor-pointer"
          >
            立即观看
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === link.path ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/category/all"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2.5 rounded-full text-center whitespace-nowrap transition-all cursor-pointer"
            >
              立即观看
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}